export const PanelEventName = {
  STATEBOX_STATE_CHANGED: 'stateboxStateChanged',
}
